module.exports = __webpack_public_path__ + "img/ggcword.24af753d.png";